export default function selectNotEpty(element, data) {
    element.addEventListener("change", update);
    // после reset() формы change не стреляет — clearForm шлёт input
    element.addEventListener("input", update);
    update();

    function update() {
        const value = element.value;
        element.classList.toggle("not-empty", value != null && value != undefined && value != "");
    }
}
